import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { brl } from "@/components/shop/theme";

const LABEL = { PENDING: "Aguardando", CASH_PENDING: "Em espécie", PAID: "Pago", SHIPPED: "Enviado", CANCELED: "Cancelado", EXPIRED: "Expirado" };
const COLOR = { PENDING: "text-amber-300", CASH_PENDING: "text-amber-300", PAID: "text-emerald-400", SHIPPED: "text-cyan-300", CANCELED: "text-red-400", EXPIRED: "text-zinc-400" };

const OrderRow = ({ o, onStatus }) => (
  <li data-testid={`admin-order-${o.public_id}`} className="rounded-xl border border-white/10 bg-[#0e1120] p-4 text-sm">
    <div className="flex flex-wrap items-center justify-between gap-2">
      <p className="font-semibold">#{o.public_id.slice(0, 8).toUpperCase()} · {o.quantity}x {o.product?.name}</p>
      <select data-testid={`admin-order-status-${o.public_id}`} value={o.status} onChange={(e) => onStatus(o, e.target.value)} className={`rounded-md border border-white/15 bg-black/40 px-2 py-1 ${COLOR[o.status]}`}>
        {Object.entries(LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
      </select>
    </div>
    <p className="mt-1 text-zinc-400">{new Date(o.created_at).toLocaleString("pt-BR")} · Total {brl(o.total)} · {o.shipping?.service} {o.shipping?.service_id === 0 ? "(a combinar)" : brl(o.shipping?.price)}</p>
    <p className="mt-2">{o.customer?.name} · {o.customer?.phone} · {o.customer?.email}</p>
    <p className="text-zinc-300">{o.address?.street}, {o.address?.number} {o.address?.complement} · {o.address?.district} · {o.address?.city}/{o.address?.state} · CEP {o.address?.cep}</p>
    {(o.customization?.note || o.customization?.photo_url) && (
      <p className="mt-2 text-zinc-300">Personalização: {o.customization.note || "—"} {o.customization.photo_url && <a href={o.customization.photo_url} target="_blank" rel="noreferrer" className="text-cyan-300 underline">ver foto</a>}</p>
    )}
  </li>
);

export const OrdersList = () => {
  const [orders, setOrders] = useState([]);
  const load = async () => {
    try {
      const { data } = await api.get("/admin/orders");
      setOrders(Array.isArray(data) ? data : []);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  useEffect(() => { load(); }, []);
  const onStatus = async (o, status) => {
    try { await api.put(`/admin/orders/${o.public_id}/status`, { status }); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <ul className="mt-8 space-y-3" data-testid="admin-orders-list">
      {orders.map((o) => <OrderRow key={o.public_id} o={o} onStatus={onStatus} />)}
      {orders.length === 0 && <p className="text-zinc-400">Nenhum pedido ainda.</p>}
    </ul>
  );
};
